import type { IconSvgObject } from './types';

const BabyBed01Icon: IconSvgObject = [
  ["path", { d: "M12 7L12 15M8 7L8 15M16 7L16 15", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 20V5C20 4.44772 20.4477 4 21 4H21.5M4 20V5C4 4.44772 3.55229 4.00001 3.00001 4L2.5 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4 7H20", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M4 15H20", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M4 18H20", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default BabyBed01Icon;
